import { useState, useMemo } from 'react'
import { applyFilters, extractFilterValues, splitByStatus } from '../utils/filters'

const useDischargeFilters = (data) => {
  const [searchText, setSearchText] = useState('')
  const [departmentFilter, setDepartmentFilter] = useState('all')
  const [statusFilter, setStatusFilter] = useState('all')
  const [dateRange, setDateRange] = useState(null)

  // Extract filter values from data
  const filterValues = useMemo(() => extractFilterValues(data), [data])

  // Apply filters to data
  const filteredData = useMemo(() => {
    return applyFilters(data, {
      searchText,
      departmentFilter,
      statusFilter,
      dateRange
    })
  }, [data, searchText, departmentFilter, statusFilter, dateRange])

  // Split filtered data by status
  const { completedDischarges, pendingDischarges } = useMemo(() => {
    return splitByStatus(filteredData)
  }, [filteredData])

  return {
    // Filter values
    filterValues,
    // Filter states
    searchText,
    setSearchText,
    departmentFilter,
    setDepartmentFilter,
    statusFilter,
    setStatusFilter,
    dateRange,
    setDateRange,
    // Filtered data
    filteredData,
    completedDischarges,
    pendingDischarges
  }
}

export default useDischargeFilters
